import React, { FC } from 'react';
import styles from './notification_watcher_title.module.scss';

export const NotificationWatcherTitle: FC = ({ children }) => (
  <span className={styles.container}>{children}</span>
);
